import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../../api/axios'
import endpoints from '../../../api/endpoints'
import { extractApiErrorMessage } from '../../../utils/apiError'

export type ApproverStatusChangeFlag =
  | 'A' // Approve
  | 'P' // Partial Approve
  | 'D' // Deny
  | 'H' // Hold
  | 'X' // Return
  | 'O'
  | 'RO'

export interface ApproverStatusChangePayload {
  TOReqId: string
  approveDenyHoldReleaseFlag: ApproverStatusChangeFlag
  approveDenyComments: string

  approverDenialReason?: string

  heldUntilDate?: string
  holdStartDate?: string

  tortPartialApprovedChecked?: string[]
  tortPartialApprovedUnChecked?: string[]
}

interface StatusChangeState {
    loading: boolean
    success: boolean
    error: string | null
}

const initialState: StatusChangeState = {
    loading: false,
    success: false,
    error: null,
}

export const changeApproverRequestStatus = createAsyncThunk(
  'approver/changeStatus',
  async (
    payload: ApproverStatusChangePayload,
    { rejectWithValue, signal }
  ) => {
    try {
      const response = await api.put(
        endpoints.approver.statusChange,
        payload,
        { signal }
      )

      return response.data
    } catch (error) {
      return rejectWithValue(
        extractApiErrorMessage(
          error,
          'Failed to update request status'
        )
      )
    }
  }
)

const approverStatusChangeSlice = createSlice({
  name: 'approverStatusChange',
  initialState,
  reducers: {
    clearApproverStatusChange(state) {
        state.loading = false
        state.success = false
        state.error = null
    },
  },
  extraReducers: (builder) => {
  builder
    .addCase(changeApproverRequestStatus.pending, (state) => {
      state.loading = true
      state.success = false
      state.error = null
    })
    .addCase(changeApproverRequestStatus.fulfilled, (state) => {
      state.loading = false
      state.success = true
    })
    .addCase(changeApproverRequestStatus.rejected, (state, action) => {
      state.loading = false
      state.success = false
      state.error = action.payload as string
    })
}
})

export const { clearApproverStatusChange } =
  approverStatusChangeSlice.actions

export default approverStatusChangeSlice.reducer